import React from 'react';

export default function Error(props){

  return (<div>
    Sorry something went wrong
  </div>);
}